import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { MERCHANT_TYPE } from 'domains/merchant/constants/merchant-constants'

/**
 * To give nice look in merchant type by given merchant type of the merchant
 * @param {string} merchant_type merchant type. available value
 * - `merchant_list`
 * - `merchant_full`
 */
const MerchantBadge = ({ merchant_type }) => {

  const colorMap = {
    [MERCHANT_TYPE.MERCHANT_LIST] : 'danger',
    [MERCHANT_TYPE.MERCHANT_FULL] : 'success'
  }

  const color = colorMap[merchant_type] || 'default'

  return <StatusBadge color={ color } label={ merchant_type } />
}

MerchantBadge.propTypes = {
  merchant_type: PropTypes.string
}

export default MerchantBadge
